import { RawDraftContentState } from 'draft-js';
import { getEmptyEditorState } from '../components/widgets/helpers';
import { ContentTableWidget, Row } from '../types';
import { cloneArray, insertAtIndex, removeAtIndex } from './utils';

const generateNewRow = (numColumns: number) => {
  const row: Row = { cells: [] };

  for (let i = 0; i < numColumns; i++) {
    row.cells.push(generateNewCell());
  }

  return row;
};

const generateNewCell = () => {
  return {
    content: getEmptyEditorState(),
    properties: {},
  };
};

export const insertRow = (table: ContentTableWidget, index: number) => ({
  properties: {
    numRows: table.properties.numRows + 1,
    numColumns: table.properties.numColumns,
  },
  rows: insertAtIndex(
    table.rows,
    index,
    generateNewRow(table.properties.numColumns),
  ),
});

export const removeRow = (table: ContentTableWidget, index: number) => {
  return {
    properties: {
      numRows: table.properties.numRows - 1,
      numColumns: table.properties.numColumns,
    },
    rows: removeAtIndex(table.rows, index),
  };
};

export const insertColumn = (table: ContentTableWidget, index: number) => {
  return {
    properties: {
      numRows: table.properties.numRows,
      numColumns: table.properties.numColumns + 1,
    },
    rows: table.rows.map(row => {
      return {
        cells: insertAtIndex(row.cells, index, generateNewCell()),
      };
    }),
  };
};

export const removeColumn = (table: ContentTableWidget, index: number) => {
  return {
    properties: {
      numRows: table.properties.numRows,
      numColumns: table.properties.numColumns - 1,
    },
    rows: table.rows.map(row => ({ cells: removeAtIndex(row.cells, index) })),
  };
};

export const editCellsContent = (
  table: ContentTableWidget,
  cells: Array<{
    rowIndex: number;
    columnIndex: number;
    content: RawDraftContentState;
  }>,
) => {
  const newRows = cloneArray(table.rows);

  cells.forEach(({ rowIndex, columnIndex, content }) => {
    newRows[rowIndex].cells[columnIndex].content = content;
  });

  return {
    ...table,
    rows: newRows,
  };
};
